import { render, staticRenderFns } from "./disposalSiteData.vue?vue&type=template&id=0f47b003&scoped=true&"
import script from "./disposalSiteData.vue?vue&type=script&lang=js&"
export * from "./disposalSiteData.vue?vue&type=script&lang=js&"
import style0 from "./disposalSiteData.vue?vue&type=style&index=0&id=0f47b003&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f47b003",
  null
  
)

export default component.exports